
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dorm-room-movers-college-moving-storage",
      function () {
        return require("private-next-pages/dorm-room-movers-college-moving-storage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dorm-room-movers-college-moving-storage"])
      });
    }
  